import { OutputDateRange } from "../types/OutputDateRange";

export const initOutputDateRange: OutputDateRange = {
  start: "",
  end: "",
};
